import { ContactSupport } from '@mui/icons-material';
import { Box, Button, styled, Typography } from "@mui/material";
import './adminconsole.css';
import { useTranslation } from 'react-i18next';
import { SupportButton } from '../../../components/Button/SupportButton/SupportButton';

const CustomButton = styled(Button)({
    backgroundColor: '#22638D',
});

export const AdminConsoleSupport = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{
            height: '213px',
            width: '312px',
            border: '1px solid #0000001A',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: '#FFFFFF',
            padding: '20px',
        }}>
            <ContactSupport sx={{
                width: '40px',
                height: '40px',
                color: '#22638D',
            }} />
            <Typography sx={{
                font: 'normal normal 600 16px/24px Segoe UI',
                fontWeight: 'semibold',
                color: '#2D2D2D',
            }}>{t("AdminConsole.NeedToTalkToSupport")}</Typography>
            <Typography sx={{
                font: 'normal normal normal 14px/21px Segoe UI',
                color: '#2D2D2D',
            }}>{t("AdminConsole.ContactOurSupportTeamByClickingTheButtonBelow")}</Typography>
            <SupportButton />
        </Box>
    )
}

